<template>
  <section class="container">
    <h1>Talent Concept</h1>
    <div class="content">
      <div class="left animate__animated animate__fadeInLeft">
        <img :src="$baseURL + info.left_thumb" />
      </div>
      <div class="right animate__animated animate__fadeInRight">
        <h2>{{ info.left_content[0] }}</h2>
        <p>
          {{ info.left_content[1] }}
        </p>
        <h2>{{ info.left_content[2] }}</h2>
        <p>
          {{ info.left_content[3] }}
        </p>
      </div>
    </div>
  </section>

  <section class="gh">
    <div class="container">
      <h1>Humanistic Concern</h1>
      <div class="cont">
        <div>
          <img :src="$baseURL + info.prcarrs[0]" />
          <img :src="$baseURL + info.prcarrs[1]" />
        </div>
        <div>
          <img :src="$baseURL + info.prcarrs[2]" />
          <img :src="$baseURL + info.prcarrs[3]" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import service from "@/assets/js/service";

export default {
  data() {
    return {
      info: { left_content: ["", "", "", ""], prcarrs: ["", "", "", ""] },
    };
  },
  methods: {
    async contactIndex() {
      let res = await service.contactIndex();
      this.info = res.data.company;
      this.info.left_content = [
        ...this.info.left_content.split("\n")[0].split("||"),
        ...this.info.left_content.split("\n")[1].split("||"),
      ];
    },
  },
  created() {
    this.contactIndex();
  },
};
</script>

<style lang="less" scoped>
h1 {
  font-size: 30px;
  margin-bottom: 30px;
}

.content {
  display: flex;

  .left {
    width: 50%;

    img {
      width: 100%;
    }
  }

  .right {
    padding-left: 40px;
    flex: 1;
    background-image: url("../../assets/image/countact_ln.svg");
    background-position: center;
    background-size: auto 100%;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    justify-content: center;

    h2 {
      font-size: 22px;
    }

    p {
      font-size: 16px;
      color: #666;

      &:first-of-type {
        margin-bottom: 60px;
      }
    }
  }
}

.gh {
  background-image: url("../../assets/image/countact_gh.svg");
  background-position: bottom left;
  background-size: auto 75%;
  background-repeat: no-repeat;

  .cont {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    margin-top: 100px;

    div {
      width: 35%;
      margin-left: 30px;

      img {
        width: 100%;
        display: block;

        &+img {
          margin-top: 30px;
        }
      }

      &:last-child {
        transform: translateY(-100px);
      }
    }
  }
}

@media (max-width: 950px) {
  .content {
    display: block;

    .left {
      width: 100%;
    }

    .right {
      padding-left: 0;
      background: none;

      h2 {
        margin-top: 10px;
      }

      p {
        &:first-of-type {
          margin-bottom: 20px;
        }
      }
    }
  }
}

@media (max-width: 450px) {
  .gh {
    .cont {
      div {
        width: 45%;
      }
    }
  }
}
</style>